import { ReactElement } from 'react';
import { TitleContainer } from 'components/TitleContainer';
import type { OutletOrServiceCategory } from './types';
import { Vendor } from '../vendor/types';

// Embedded our full
type T = Pick<OutletOrServiceCategory, 'id' | 'name' | 'kind' | 'type'> & {
  vendor?: Vendor | null;
};
export function OutletOrServiceCategoryTitle({
  id,
  name,
  kind,
  type,
  flat,
  className,
  vendor,
}: T & {
  className?: string;
  flat?: boolean;
}): ReactElement {
  const mediaTitle = vendor && vendor.name !== name ? `${vendor.name} / ${name}` : name;
  let subtitle = kind.toString();

  if (type) {
    subtitle = `${subtitle} (${type})`;
  }
  return (
    <TitleContainer
      testId={`outlet-or-servicecategory-${id}`}
      className={className}
      flat={flat}
      title={mediaTitle}
      subtitle={subtitle}
    />
  );
}
